import { render, staticRenderFns } from "./ClientEventsByProcedureCategory.vue?vue&type=template&id=4129d477&scoped=true"
import script from "./ClientEventsByProcedureCategory.vue?vue&type=script&lang=js"
export * from "./ClientEventsByProcedureCategory.vue?vue&type=script&lang=js"
import style0 from "./ClientEventsByProcedureCategory.vue?vue&type=style&index=0&id=4129d477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4129d477",
  null
  
)

export default component.exports